var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49504 13.9961C7.69349 13.9973 7.8878 13.9393 8.05318 13.8296C8.21856 13.7199 8.34752 13.5634 8.42362 13.3801C8.49972 13.1969 8.51952 12.9951 8.48048 12.8005C8.44144 12.6059 8.34534 12.4273 8.20443 12.2876L2.90892 7.00207L8.20443 1.71655C8.39258 1.5284 8.49828 1.27322 8.49828 1.00715C8.49828 0.8754 8.47233 0.744943 8.42191 0.623224C8.37149 0.501505 8.29759 0.390909 8.20443 0.297749C8.11128 0.204589 8.00068 0.130691 7.87896 0.0802738C7.75724 0.0298562 7.62678 0.00390625 7.49504 0.00390625C7.22896 0.00390625 6.97378 0.109605 6.78564 0.297749L0.790716 6.29267C0.604623 6.47987 0.50017 6.73311 0.50017 6.99707C0.50017 7.26103 0.604623 7.51427 0.790716 7.70148L6.78564 13.6964C6.87817 13.7908 6.98852 13.8659 7.1103 13.9174C7.23207 13.9688 7.36284 13.9956 7.49504 13.9961Z",
    fill: "#C70048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext1);
export default __webpack_public_path__ + "static/media/next1.c7ae1e2dc05bbc87dba276491ca3b598.svg";
export { ForwardRef as ReactComponent };